import { environment } from "../../environments/environment";

export class BaseService {
  getUrlBase() {
    return `${window.location.protocol}${environment.apiUrl}/`;
  }
}
